/**
 * Define the strategy that will be used for hit caching
 */
export var CacheStrategy;
(function (CacheStrategy) {
    /**
     * When a hit is emitted, it will be first cached in database using IHitCacheImplementation and added into the pool, then after batching and sending, it will also be flushed from database using IHitCacheImplementation.
     *
     * Note: the SDK has a default cache implementation for browser using localStorage
     */
    CacheStrategy[CacheStrategy["CONTINUOUS_CACHING"] = 0] = "CONTINUOUS_CACHING";
    /**
     * When a hit is emitted, it will be added into the pool, then after batching and sending, all database hits will be flushed, then the entire pool will be cached using IHitCacheImplementation for both actions.
     */
    CacheStrategy[CacheStrategy["PERIODIC_CACHING"] = 1] = "PERIODIC_CACHING";
})(CacheStrategy || (CacheStrategy = {}));
